import { useEffect } from 'react';

import { EVENT_FILTERS_READY } from '@/constants/events';
import getFiltersInitialValues from '@/features/filters/helpers/getFiltersInitialValues';
import getFiltersQueryValues from '@/features/filters/helpers/getFiltersQueryValues';
import useFiltersData from '@/features/filters/hooks/useFiltersData';
import { useAppDispatch, useAppSelector } from '@/features/hooks';
import { rootActions, rootSelectors } from '@/features/store';
import useQueryParams from '@/hooks/useQueryParams';
import mergeDeep from '@/utils/mergeDeep';
import sendEvent from '@/utils/sendEvent';

/**
 * Хук для установки начальных значений фильтров на основе
 * query-параметров и начальных значений фильтров указанных при инициализации
 */
const useFilterSettings = () => {
  const dispatch = useAppDispatch();

  const queryParams = useQueryParams();

  const filtersReady = useAppSelector(rootSelectors.installation.filtersSelector);
  const filtersInitialSettings = useAppSelector(
    rootSelectors.config.filtersInitialValuesSelector,
  );
  const flattenFilterGridItems = useAppSelector(
    rootSelectors.config.flattenFilterGridItemsSelector,
  );
  const sortInitialValues = useAppSelector(
    rootSelectors.config.sortInitialValuesSelector,
  );

  const { isSuccess, data: filters } = useFiltersData();

  useEffect(() => {
    if (!filtersReady && isSuccess) {
      const initialValues = getFiltersInitialValues(
        filtersInitialSettings,
        flattenFilterGridItems,
        filters,
      );
      const queryValues = getFiltersQueryValues(
        queryParams,
        flattenFilterGridItems,
        filters,
      );
      const mergedValues = mergeDeep(queryValues, initialValues);
      if (Object.keys(mergedValues).length !== 0) {
        dispatch(rootActions.choice.setFilters(mergedValues));
      }
      if (!!sortInitialValues && !!sortInitialValues.length) {
        dispatch(rootActions.choice.setSort(sortInitialValues));
      }
      dispatch(rootActions.installation.setFiltersReady(true));
      sendEvent(EVENT_FILTERS_READY);
    }
  }, [isSuccess]);
};

export default useFilterSettings;
